module.exports = __webpack_public_path__ + "img/search-no-data.4654ca2b.svg";